import { useMemo } from "react";

import { LabObservationLevel } from "@/Common/Api/ManualResults/Dtos/LabObservationsDto";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";

interface ObservationFlagDropdownProps {
    value: LabObservationLevel | null;
    onChange: (value: LabObservationLevel) => void;
    dataCy?: string;
    id: string;
}

const levelToLabelMap: Record<LabObservationLevel, string> = {
    [LabObservationLevel.Normal]: "ManualResults_NormalIndicator",
    [LabObservationLevel.Abnormal]: "ManualResults_AbnormalIndicator",
    [LabObservationLevel.CriticallyHigh]: "ManualResults_CriticallyHighIndicator",
    [LabObservationLevel.CriticallyLow]: "ManualResults_CriticallyLowIndicator",
    [LabObservationLevel.High]: "ManualResults_HighIndicator",
    [LabObservationLevel.Low]: "ManualResults_LowIndicator"
};

function ObservationFlagDropdown({ id, value, onChange, dataCy }: Readonly<ObservationFlagDropdownProps>): JSX.Element {
    const { getText } = useTranslation();
    const optionsElement = useMemo(() => Object.keys(LabObservationLevel).map((key: string) => (
        <option
            data-cy={key}
            key={key}
            value={key}
        >
            {getText(levelToLabelMap[key])}
        </option>
    )), [getText]);

    const handleChange = (event: React.ChangeEvent<HTMLSelectElement>): void => {
        onChange(LabObservationLevel[event.target.value as keyof typeof LabObservationLevel]);
    };

    return (
        <select
            className="form-control myle-control"
            onChange={handleChange}
            value={value}
            data-cy={dataCy}
            id={id}
        >
            <option value="" key="0" />
            {optionsElement}
        </select>
    );
}

export { ObservationFlagDropdown };
